/* src/app/private/components/registration/create-student-profile/create-student-profile.component.scss */
/*# sourceMappingURL=create-student-profile.component.css.map */
